import { CreatedByIdentity, Pattern, Status } from '@wix/ambassador-ai-scheduling-assistant-v1-recurring-schedule/types';
import { IdentityType } from '../../commonTypes/CreatedBy';
import { contactDisplayApiToContactDisplay } from '../Contact';
import { serviceDisplayApiToServiceDisplay } from '../Service';
import { isValidEnrichedRecurringSchedule, isValidRecurringSchedule, RecurringSchedulePattern, RecurringScheduleStatus } from '.';
export function convertRecurringSchedulePatternToPattern(pattern) {
  switch (pattern) {
    case RecurringSchedulePattern.ON_DEMAND:
      return Pattern.ON_DEMAND;
    case RecurringSchedulePattern.PRE_SCHEDULED:
      return Pattern.PRE_SCHEDULED;
    default:
      throw new Error(`Unknown pattern: ${pattern}`);
  }
}
export function convertPatternToRecurringSchedulePattern(pattern) {
  switch (pattern) {
    case Pattern.ON_DEMAND:
      return RecurringSchedulePattern.ON_DEMAND;
    case Pattern.PRE_SCHEDULED:
      return RecurringSchedulePattern.PRE_SCHEDULED;
    default:
      throw new Error(`Unknown pattern: ${pattern}`);
  }
}
export function convertRecurringScheduleStatusToStatus(status) {
  switch (status) {
    case RecurringScheduleStatus.PENDING:
      return Status.PENDING;
    case RecurringScheduleStatus.ACTIVE:
      return Status.ACTIVE;
    case RecurringScheduleStatus.PAUSED_BY_CLIENT:
      return Status.PAUSED_BY_CLIENT;
    case RecurringScheduleStatus.PAUSED_BY_BUSINESS:
      return Status.PAUSED_BY_BUSINESS;
    case RecurringScheduleStatus.INACTIVE:
      return Status.INACTIVE;
    case RecurringScheduleStatus.INVALID:
      return Status.INVALID;
    default:
      throw new Error(`Unknown status: ${status}`);
  }
}
export function convertStatusToRecurringScheduleStatus(status) {
  switch (status) {
    case Status.PENDING:
      return RecurringScheduleStatus.PENDING;
    case Status.ACTIVE:
      return RecurringScheduleStatus.ACTIVE;
    case Status.PAUSED_BY_CLIENT:
      return RecurringScheduleStatus.PAUSED_BY_CLIENT;
    case Status.PAUSED_BY_BUSINESS:
      return RecurringScheduleStatus.PAUSED_BY_BUSINESS;
    case Status.INACTIVE:
      return RecurringScheduleStatus.INACTIVE;
    case Status.INVALID:
      return RecurringScheduleStatus.INVALID;
    default:
      throw new Error(`Unknown status: ${status}`);
  }
}
export function convertRecurringSchedulesFilter(filter) {
  return {
    ...(filter.pattern != null && {
      pattern: convertRecurringSchedulePatternToPattern(filter.pattern)
    }),
    ...(filter.status != null && {
      'status.status': convertRecurringScheduleStatusToStatus(filter.status)
    })
  };
}
export function convertCreatedByIdentityToIdentityType(createdByIdentity) {
  switch (createdByIdentity) {
    case CreatedByIdentity.ASSISTANT:
      return IdentityType.ASSISTANT;
    case CreatedByIdentity.ACCOUNT:
      return IdentityType.ACCOUNT;
    case CreatedByIdentity.CONTACT:
      return IdentityType.CONTACT;
    default:
      throw new Error(`Unknown createdByIdentity: ${createdByIdentity}`);
  }
}
export function recurringScheduleApiToRecurringScheduleEntity(recurringSchedule) {
  var _recurringSchedule$st, _recurringSchedule$st2;
  if (!recurringSchedule) {
    throw new Error('Invalid recurringScheduleApi', {
      cause: {
        recurringSchedule
      }
    });
  }
  const convertedRecurringSchedule = {
    id: recurringSchedule.id,
    revision: recurringSchedule.revision,
    guidelines: recurringSchedule.guidelines,
    pattern: convertPatternToRecurringSchedulePattern(recurringSchedule.pattern),
    status: convertStatusToRecurringScheduleStatus(recurringSchedule == null || (_recurringSchedule$st = recurringSchedule.status) == null ? void 0 : _recurringSchedule$st.status),
    notes: recurringSchedule == null || (_recurringSchedule$st2 = recurringSchedule.status) == null ? void 0 : _recurringSchedule$st2.notes,
    serviceId: recurringSchedule.serviceId,
    providerId: recurringSchedule.providerId,
    ...(recurringSchedule.recurringScheduleReference && {
      recurringScheduleReference: {
        metaSiteId: recurringSchedule.recurringScheduleReference.metaSiteId,
        recurringScheduleId: recurringSchedule.recurringScheduleReference.recurringScheduleId
      }
    }),
    scheduledAt: recurringSchedule.scheduledAt,
    createdBy: recurringSchedule.createdBy,
    createdByIdentity: convertCreatedByIdentityToIdentityType(recurringSchedule.createdByIdentity),
    frequency: recurringSchedule.frequency
  };
  if (isValidRecurringSchedule(convertedRecurringSchedule)) {
    return convertedRecurringSchedule;
  }
  throw new Error('Invalid RecurringSchedule data', {
    cause: {
      recurringSchedule
    }
  });
}
export const enrichedRecurringScheduleApiToEnrichedRecurringScheduleEntity = enrichedRecurringSchedule => {
  var _enrichedRecurringSch;
  if (!enrichedRecurringSchedule) {
    throw new Error('Invalid enrichedRecurringScheduleApi', {
      cause: {
        enrichedRecurringSchedule
      }
    });
  }
  const convertedEnrichedRecurringSchedule = {
    ...recurringScheduleApiToRecurringScheduleEntity(enrichedRecurringSchedule),
    service: serviceDisplayApiToServiceDisplay(enrichedRecurringSchedule.service),
    lastScheduledAt: enrichedRecurringSchedule.lastScheduledAt,
    contacts: ((_enrichedRecurringSch = enrichedRecurringSchedule.contacts) == null ? void 0 : _enrichedRecurringSch.map(contactDisplayApiToContactDisplay)) ?? [],
    bookedAppointments: enrichedRecurringSchedule.bookedAppointments ?? 0,
    insights: enrichedRecurringSchedule.insights ?? []
  };
  if (isValidEnrichedRecurringSchedule(convertedEnrichedRecurringSchedule)) {
    return convertedEnrichedRecurringSchedule;
  }
  throw new Error('Invalid EnrichedRecurringSchedule data', {
    cause: {
      enrichedRecurringSchedule
    }
  });
};
//# sourceMappingURL=converters.js.map